import React from 'react'
import { Form, Input, Button, Modal, Select, Switch } from 'antd'

const FormItem = Form.Item
const { TextArea } = Input
const { Option } = Select

const timeArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okType: 'danger',
      okText: 'Да',
      cancelText: 'Нет',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }
    const isCreateForm = this.props.type === 'create'

    return (
      <Form onSubmit={this.handleOnSubmit}>
        <FormItem label='Название' {...formItemLayout}>
          {getFieldDecorator('s_name', {
            rules: [{ required: true, message: 'Пожалуйста введите название.' }],
          })(<Input placeholder='Название' />)}
        </FormItem>
        <FormItem label='Номер' {...formItemLayout}>
          {getFieldDecorator('s_number', {
            rules: [{ message: 'Пожалуйста введите номер.' }],
          })(<Input placeholder='Номер' />)}
        </FormItem>
        <FormItem label='Идентификатор' {...formItemLayout}>
          {getFieldDecorator('s_identity', {
            rules: [{ required: true, message: 'Пожалуйста введите идентификатор.' }],
          })(<Input placeholder='Идентификатор' />)}
        </FormItem>
        <FormItem label='Адрес' {...formItemLayout}>
          {getFieldDecorator('s_address', {
            rules: [{ message: 'Пожалуйста введите адрес.' }],
          })(<TextArea rows={3} placeholder='Адрес' />)}
        </FormItem>
        <FormItem label='Часовой пояс' {...formItemLayout}>
          {getFieldDecorator('n_time_offset', {
            rules: [{ message: 'Пожалуйста введите часовой пояс.' }],
          })(<Select
            placeholder='Часовой пояс'
          >
            {
                timeArray.map(item => <Option key={item} value={(parseInt(item || '0') - 7).toString()}>{`UTC +${item}`}</Option>)
              }
             </Select>)}
        </FormItem>
        <FormItem label='Блокировка' {...formItemLayout}>
          {getFieldDecorator('n_disable', {
                              valuePropName: 'checked',
                              rules: [{ required: false, message: 'Блокировка.' }],
                          })(<Switch />)}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            {isCreateForm ? 'Создать' : 'Сохранить'}
          </Button>
          {
            !isCreateForm &&
            <Button
              loading={this.props.isDeleteItemLoading}
              type='danger'
              htmlType='button'
              onClick={this.handleOnDelete}
            >
              Удалить
            </Button>
          }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    return {
      s_name: Form.createFormField(formFieldValues.s_name),
      s_number: Form.createFormField(formFieldValues.s_number),
      s_address: Form.createFormField(formFieldValues.s_address),
      s_identity: Form.createFormField(formFieldValues.s_identity),
      n_time_offset: Form.createFormField(formFieldValues.n_time_offset),
      n_disable: Form.createFormField(formFieldValues.n_disable),
    }
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/SellerForm/PointList/Form/PointForm.jsx